import React, { useEffect, useState } from "react";
import styles from "./CookieConsentBanner.module.css";

const CookieConsentBanner = ({ onAccept }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem("cookie_consent");
        if (!consent) setVisible(true);
    }, []);

    const handleAccept = () => {
        localStorage.setItem("cookie_consent", "true");
        setVisible(false);
        onAccept();
    };

    if (!visible) return null;

    return (
        <>
            <div className="container-custom">
                <div className={styles.cookieBanner}>
                    <div className={styles.content}>
                        <div className={styles.text}>
                            Мы используем файлы cookies для обеспечения работы сервиса.
                            Продолжая пользоваться сайтом, вы соглашаетесь с {" "}
                            <a
                                href={process.env.REACT_APP_API_URL + 'policy/privacyPolicy.pdf'}
                                target="_blank"
                            >
                                Политикой конфиденциальности
                            </a>
                            {" "} и использованием cookies.
                        </div>
                        <button
                            className={styles.button}
                            onClick={handleAccept}
                        >
                            Согласен
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CookieConsentBanner;
